import React from 'react';
import type { DisallowedTagsModes } from 'sanitize-html';
import sanitizeHtml from 'sanitize-html';

interface ComponentProps {
  html: string | number;
  additionalTags?: string[];
  /** Discard not allowed html tags by default */
  disallowedTagsMode?: DisallowedTagsModes;
}

function SanitizeHTML({ html, additionalTags, disallowedTagsMode = 'discard' }: ComponentProps) {
  const formattedHtml = html.toString().replaceAll('<br>', '<br />');

  const execSanitizedHtml = (decodeEntities?: boolean) => sanitizeHtml(
    formattedHtml, {
      allowedTags: [
        'b', 'br', 'big', 'em', 'i', 'small', 'strong', 'sub', 'sup', 'u', 'pre', ...(additionalTags || []),
      ],
      allowedAttributes: { '*': ['style', 'href', 'target', 'alt', 'title'] },
      parseStyleAttributes: false,
      disallowedTagsMode,
      parser: {
        decodeEntities: decodeEntities === undefined ? true : decodeEntities,
      },
    },
  );

  const sanitizedHtml = execSanitizedHtml();

  // If nothing has been removed, it means the string is correct (with html tags or not) and can be rendered
  if (
    disallowedTagsMode === 'discard'
    || (formattedHtml.toLowerCase().replace(/\s/g, '') === execSanitizedHtml(false).toLowerCase().replace(/\s/g, ''))
  ) {
    return (
      <span
         
        dangerouslySetInnerHTML={{
          __html: sanitizedHtml,
        }}
      />
    );
  }

  // Otherwise rendered as string and not valid html
  return (
    <span>{formattedHtml}</span>
  );
}

export default SanitizeHTML;
